import { tv } from 'tailwind-variants';

export const labelStyles = tv({
  base: 'select-none text-zinc-500 dark:text-zinc-400 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      lg: 'text-lg',
      xl: 'text-xl',
    },
    disabled: {
      true: 'pointer-events-none',
    },
    error: {
      true: 'text-destructive',
    },
  },
});
